import { get } from "../../service/api";
import { invoiceSearchParams } from "./invoiceSearchParams";

const ExportAdminInvoices = async (searchFields, options = {}) => {
  const params = invoiceSearchParams(searchFields, options);
  const parts = Object.keys(params).map(
    (key) => `${key}=${encodeURIComponent(params[key])}`
  );
  if (!parts.length) {
    return get("/invoice/export");
  }
  return get(`/invoice/export?${parts.join("&")}`);
};

export default ExportAdminInvoices;
